/**
 * Routes Configuration
 * Centralized route definitions for the application
 */

import React from 'react';
import { PublicRouteGuard } from './RouteGuard';

// Auth pages
import Login from '../../features/auth/pages/Login';
import Signup from '../../features/auth/pages/Signup';
import Forgotpassword from '../../features/auth/pages/Forgot_password';
import Resetpassword from '../../features/auth/pages/Reset_password';

// Dashboard
import Dashboard from '../../features/dashboard/Dashboard';

// Vaccine Management
import Vaccines from '../../features/vaccines/management/pages/Vaccines';
import VaccineDetail from '../../features/vaccines/management/pages/VaccineDetail';
import StockManagement from '../../features/vaccines/stock/pages/StockManagement';
import StockManagementDetail from '../../features/vaccines/stock/pages/StockManagementDetail';
import VaccinationPlan from '../../features/vaccines/plan/pages/VaccinationPlan';
import VaccinationPlanDetail from '../../features/vaccines/plan/pages/VaccinationPlanDetail';
import VaccineDispatch from '../../features/vaccines/dispatch/pages/VaccineDispatch';
import VaccineDispatchDetail from '../../features/vaccines/dispatch/pages/VaccineDispatchDetail';
import VaccineRecord from '../../features/vaccines/record/pages/VaccineRecord';
import VaccineRecordDetail from '../../features/vaccines/record/pages/VaccineRecordDetail';
import SupplierManagement from '../../features/vaccines/supplier/pages/SupplierManagement';
import SupplierDetail from '../../features/vaccines/supplier/pages/SupplierDetail';

// Location Management
import Distric from '../../features/locations/district/pages/Distric';
import DistrictDetail from '../../features/locations/district/pages/DistrictDetail';
import Taluka from '../../features/locations/taluka/pages/Taluka';
import TalukaDetail from '../../features/locations/taluka/pages/TalukaDetail';
import Village from '../../features/locations/village/pages/Village';
import VillageDetail from '../../features/locations/village/pages/VillageDetail';
import Centers from '../../features/locations/center/pages/Centers';
import CenterDetail from '../../features/locations/center/pages/CenterDetail';

// Other Management
import Appointments from '../../features/appointments/pages/Appointments';
import AppointmentDetail from '../../features/appointments/pages/AppointmentDetail';
import MedicalStaff from '../../features/medical-staff/pages/MedicalStaff';
import MedicalStaffDetail from '../../features/medical-staff/pages/MedicalStaffDetail';
import ParentRecordsPage from '../../features/patients/pages/PatientRecordsPage';
import PatientDetail from '../../features/patients/pages/PatientDetail';
import ChildrenRecordsPage from '../../features/children/pages/ChildRecordsPage';
import ChildDetail from '../../features/children/pages/ChildDetail';
import ChildVaccinationRecordsPage from '../../features/children/pages/ChildVaccinationRecordsPage';
import ChildVaccinationPlanPage from '../../features/children/pages/ChildVaccinationPlanPage';
import ChildVaccinationPlansListPage from '../../features/children/pages/ChildVaccinationPlansListPage';
import User from '../../features/users/pages/User';
import UserDetail from '../../features/users/pages/UserDetail';
import MyProfile from '../../features/users/components/myProfile';
import RolesPage from '../../features/roles/pages/RolesPage';
import RoleDetail from '../../features/roles/pages/RoleDetail';
import ModulesPage from '../../features/roles/pages/ModulesPage';
import PermissionsPage from '../../features/roles/pages/PermissionsPage';
import ActivityLogsPage from '../../features/activity-logs/pages/ActivityLogsPage';
import NotificationLogsPage from '../../features/notification-logs/pages/NotificationLogsPage';
import ReportsPage from '../../features/reports/pages/ReportsPage';
import ReportDetailPage from '../../features/reports/pages/ReportDetailPage';
import GeneralSettingsPage from '../../features/settings/pages/GeneralSettingsPage';

/**
 * Route Path Constants
 * Use these constants instead of hardcoded strings for paths
 */
export const ROUTES = {
  // Public Routes
  ROOT: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',

  // Dashboard
  DASHBOARD: 'dashboard',

  // Vaccine Management
  VACCINES: 'vaccines',
  STOCK_MANAGEMENT: 'stock-management',
  VACCINATION_PLAN: 'vaccination-plan',
  VACCINE_DISPATCH: 'vaccine-Transfer',
  SUPPLIER_MANAGEMENT: 'supplier-management',

  // Location Management
  DISTRICT: 'distric',
  TALUKA: 'taluka',
  VILLAGE: 'village',
  CENTERS: 'centers',

  // Other Management
  APPOINTMENTS: 'Appointments',
  VACCINATION_RECORD: 'vaccination-records',
  MEDICAL_STAFF: 'medical-staff',
  PATIENTS: 'patients',
  CHILDREN: 'children',
  USERS: 'User',
  ROLES: 'roles',
  MODULES: 'modules',
  PERMISSIONS: 'permissions',
  CHILD_VACCINATION_PLAN: 'child-vaccination-plans',
  ACTIVITY_LOGS: 'activity-logs',
  NOTIFICATION_LOGS: 'notification-logs',
  SETTINGS: 'settings',
  REPORTS: 'reports',
  PROFILE: 'profile',

  // Admin prefix
  ADMIN: '/admin',
};

/**
 * Full paths (with admin prefix) for navigation
 */
export const FULL_PATHS = {
  DASHBOARD: `${ROUTES.ADMIN}/${ROUTES.DASHBOARD}`,
  VACCINES: `${ROUTES.ADMIN}/${ROUTES.VACCINES}`,
  STOCK_MANAGEMENT: `${ROUTES.ADMIN}/${ROUTES.STOCK_MANAGEMENT}`,
  VACCINATION_PLAN: `${ROUTES.ADMIN}/${ROUTES.VACCINATION_PLAN}`,
  VACCINE_DISPATCH: `${ROUTES.ADMIN}/${ROUTES.VACCINE_DISPATCH}`,
  VACCINATION_RECORD: `${ROUTES.ADMIN}/${ROUTES.VACCINATION_RECORD}`,
  SUPPLIER_MANAGEMENT: `${ROUTES.ADMIN}/${ROUTES.SUPPLIER_MANAGEMENT}`,
  DISTRICT: `${ROUTES.ADMIN}/${ROUTES.DISTRICT}`,
  TALUKA: `${ROUTES.ADMIN}/${ROUTES.TALUKA}`,
  VILLAGE: `${ROUTES.ADMIN}/${ROUTES.VILLAGE}`,
  CENTERS: `${ROUTES.ADMIN}/${ROUTES.CENTERS}`,
  APPOINTMENTS: `${ROUTES.ADMIN}/${ROUTES.APPOINTMENTS}`,
  MEDICAL_STAFF: `${ROUTES.ADMIN}/${ROUTES.MEDICAL_STAFF}`,
  PATIENTS: `${ROUTES.ADMIN}/${ROUTES.PATIENTS}`,
  CHILDREN: `${ROUTES.ADMIN}/${ROUTES.CHILDREN}`,
  CHILD_VACCINATION_PLAN: `${ROUTES.ADMIN}/${ROUTES.CHILD_VACCINATION_PLAN}`,
  USERS: `${ROUTES.ADMIN}/${ROUTES.USERS}`,
  ROLES: `${ROUTES.ADMIN}/${ROUTES.ROLES}`,
  ACTIVITY_LOGS: `${ROUTES.ADMIN}/${ROUTES.ACTIVITY_LOGS}`,
  NOTIFICATION_LOGS: `${ROUTES.ADMIN}/${ROUTES.NOTIFICATION_LOGS}`,
  SETTINGS: `${ROUTES.ADMIN}/${ROUTES.SETTINGS}`,
  REPORTS: `${ROUTES.ADMIN}/${ROUTES.REPORTS}`,
  PROFILE: `${ROUTES.ADMIN}/${ROUTES.PROFILE}`,
};

/**
 * Public routes (no authentication required)
 */
export const publicRoutes = [
  { path: ROUTES.ROOT, redirect: ROUTES.LOGIN },
  { path: ROUTES.LOGIN, element: <PublicRouteGuard><Login /></PublicRouteGuard> },
  { path: ROUTES.SIGNUP, element: <PublicRouteGuard><Signup /></PublicRouteGuard> },
  { path: ROUTES.FORGOT_PASSWORD, element: <Forgotpassword /> },
  { path: ROUTES.RESET_PASSWORD, element: <Resetpassword /> },
];

/**
 * Protected routes (authentication required)
 */
export const protectedRoutes = [
  // Dashboard
  { path: ROUTES.DASHBOARD, element: <Dashboard />, title: 'Dashboard' },

  // Vaccine Management
  { path: ROUTES.VACCINES, element: <Vaccines />, title: 'Vaccines', module: 'vaccines' },
  { path: `${ROUTES.VACCINES}/view/:id`, element: <VaccineDetail />, title: 'View Vaccine', module: 'vaccines' },
  { path: `${ROUTES.VACCINES}/edit/:id`, element: <VaccineDetail />, title: 'Edit Vaccine', module: 'vaccines' },
  { path: `${ROUTES.VACCINES}/add`, element: <VaccineDetail />, title: 'Add Vaccine', module: 'vaccines' },
  { path: ROUTES.STOCK_MANAGEMENT, element: <StockManagement />, title: 'Vaccine Inventory', module: 'vaccine-inventory' },
  { path: `${ROUTES.STOCK_MANAGEMENT}/view/:id`, element: <StockManagementDetail />, title: 'View Vaccine Inventory', module: 'vaccine-inventory' },
  { path: `${ROUTES.STOCK_MANAGEMENT}/edit/:id`, element: <StockManagementDetail />, title: 'Edit Vaccine Inventory', module: 'vaccine-inventory' },
  { path: `${ROUTES.STOCK_MANAGEMENT}/add`, element: <StockManagementDetail />, title: 'Add Vaccine Inventory', module: 'vaccine-inventory' },
  { path: ROUTES.VACCINATION_PLAN, element: <VaccinationPlan />, title: 'Vaccination Plan', module: 'vaccines' },
  { path: `${ROUTES.VACCINATION_PLAN}/view/:id`, element: <VaccinationPlanDetail />, title: 'View Plan', module: 'vaccines' },
  { path: `${ROUTES.VACCINATION_PLAN}/edit/:id`, element: <VaccinationPlanDetail />, title: 'Edit Plan', module: 'vaccines' },
  { path: `${ROUTES.VACCINATION_PLAN}/add`, element: <VaccinationPlanDetail />, title: 'Add Plan', module: 'vaccines' },
  { path: ROUTES.VACCINE_DISPATCH, element: <VaccineDispatch />, title: 'Vaccine Transfer', module: 'vaccine-transfer' },
  { path: `${ROUTES.VACCINE_DISPATCH}/view/:id`, element: <VaccineDispatchDetail />, title: 'View Transfer', module: 'vaccine-transfer' },
  { path: `${ROUTES.VACCINE_DISPATCH}/edit/:id`, element: <VaccineDispatchDetail />, title: 'Edit Transfer', module: 'vaccine-transfer' },
  { path: `${ROUTES.VACCINE_DISPATCH}/add`, element: <VaccineDispatchDetail />, title: 'Add Transfer', module: 'vaccine-transfer' },
  { path: ROUTES.VACCINATION_RECORD, element: <VaccineRecord />, title: 'Vaccine Record', module: 'vaccination-records' },
  { path: `${ROUTES.VACCINATION_RECORD}/view/:id`, element: <VaccineRecordDetail />, title: 'View Record', module: 'vaccination-records' },
  { path: `${ROUTES.VACCINATION_RECORD}/edit/:id`, element: <VaccineRecordDetail />, title: 'Edit Record', module: 'vaccination-records' },
  { path: `${ROUTES.VACCINATION_RECORD}/add`, element: <VaccineRecordDetail />, title: 'Add Record', module: 'vaccination-records' },
  { path: ROUTES.SUPPLIER_MANAGEMENT, element: <SupplierManagement />, title: 'Supplier Management', module: 'suppliers' },
  { path: `${ROUTES.SUPPLIER_MANAGEMENT}/view/:id`, element: <SupplierDetail />, title: 'View Supplier', module: 'suppliers' },
  { path: `${ROUTES.SUPPLIER_MANAGEMENT}/edit/:id`, element: <SupplierDetail />, title: 'Edit Supplier', module: 'suppliers' },
  { path: `${ROUTES.SUPPLIER_MANAGEMENT}/add`, element: <SupplierDetail />, title: 'Add Supplier', module: 'suppliers' },

  // Location Management
  { path: ROUTES.DISTRICT, element: <Distric />, title: 'District', module: 'locations' },
  { path: `${ROUTES.DISTRICT}/view/:id`, element: <DistrictDetail />, title: 'View District', module: 'locations' },
  { path: `${ROUTES.DISTRICT}/edit/:id`, element: <DistrictDetail />, title: 'Edit District', module: 'locations' },
  { path: `${ROUTES.DISTRICT}/add`, element: <DistrictDetail />, title: 'Add District', module: 'locations' },
  { path: ROUTES.TALUKA, element: <Taluka />, title: 'Taluka', module: 'locations' },
  { path: `${ROUTES.TALUKA}/view/:id`, element: <TalukaDetail />, title: 'View Taluka', module: 'locations' },
  { path: `${ROUTES.TALUKA}/edit/:id`, element: <TalukaDetail />, title: 'Edit Taluka', module: 'locations' },
  { path: `${ROUTES.TALUKA}/add`, element: <TalukaDetail />, title: 'Add Taluka', module: 'locations' },
  { path: ROUTES.VILLAGE, element: <Village />, title: 'Village', module: 'locations' },
  { path: `${ROUTES.VILLAGE}/view/:id`, element: <VillageDetail />, title: 'View Village', module: 'locations' },
  { path: `${ROUTES.VILLAGE}/edit/:id`, element: <VillageDetail />, title: 'Edit Village', module: 'locations' },
  { path: `${ROUTES.VILLAGE}/add`, element: <VillageDetail />, title: 'Add Village', module: 'locations' },
  { path: ROUTES.CENTERS, element: <Centers />, title: 'Vaccination Centers', module: 'centers' },
  { path: `${ROUTES.CENTERS}/view/:id`, element: <CenterDetail />, title: 'View Vaccination Center', module: 'centers' },
  { path: `${ROUTES.CENTERS}/edit/:id`, element: <CenterDetail />, title: 'Edit Vaccination Center', module: 'centers' },
  { path: `${ROUTES.CENTERS}/add`, element: <CenterDetail />, title: 'Add Vaccination Center', module: 'centers' },

  // Other Management
  { path: ROUTES.APPOINTMENTS, element: <Appointments />, title: 'Appointments', module: 'appointments' },
  { path: `${ROUTES.APPOINTMENTS}/view/:id`, element: <AppointmentDetail />, title: 'View Appointment', module: 'appointments' },
  { path: `${ROUTES.APPOINTMENTS}/edit/:id`, element: <AppointmentDetail />, title: 'Edit Appointment', module: 'appointments' },
  { path: `${ROUTES.APPOINTMENTS}/add`, element: <AppointmentDetail />, title: 'Add Appointment', module: 'appointments' },
  { path: ROUTES.MEDICAL_STAFF, element: <MedicalStaff />, title: 'Medical Staff', module: 'medical-staff' },
  { path: `${ROUTES.MEDICAL_STAFF}/view/:id`, element: <MedicalStaffDetail />, title: 'View Staff', module: 'medical-staff' },
  { path: `${ROUTES.MEDICAL_STAFF}/edit/:id`, element: <MedicalStaffDetail />, title: 'Edit Staff', module: 'medical-staff' },
  { path: `${ROUTES.MEDICAL_STAFF}/add`, element: <MedicalStaffDetail />, title: 'Add Staff', module: 'medical-staff' },
  { path: ROUTES.PATIENTS, element: <ParentRecordsPage />, title: 'Parent', module: 'patients' },
  { path: `${ROUTES.PATIENTS}/view/:id`, element: <PatientDetail />, title: 'View Parent', module: 'patients' },
  { path: `${ROUTES.PATIENTS}/edit/:id`, element: <PatientDetail />, title: 'Edit Parent', module: 'patients' },
  { path: `${ROUTES.PATIENTS}/add`, element: <PatientDetail />, title: 'Add Parent', module: 'patients' },
  { path: ROUTES.CHILDREN, element: <ChildrenRecordsPage />, title: 'Children', module: 'children' },
  { path: `${ROUTES.CHILDREN}/view/:id`, element: <ChildDetail />, title: 'View Child', module: 'children' },
  { path: `${ROUTES.CHILDREN}/edit/:id`, element: <ChildDetail />, title: 'Edit Child', module: 'children' },
  { path: `${ROUTES.CHILDREN}/add`, element: <ChildDetail />, title: 'Add Child', module: 'children' },
  { path: `${ROUTES.CHILDREN}/add/:parentId`, element: <ChildDetail />, title: 'Add Child (From Parent)', module: 'children' },
  { path: `${ROUTES.CHILDREN}/:childId/vaccination-records`, element: <ChildVaccinationRecordsPage />, title: 'Vaccination Records', module: 'vaccination-records' },
  { path: `${ROUTES.CHILDREN}/:childId/vaccination-plan`, element: <ChildVaccinationPlanPage />, title: 'Child Vaccination Plan', module: 'children' },
  { path: ROUTES.CHILD_VACCINATION_PLAN, element: <ChildVaccinationPlansListPage />, title: 'Child Vaccination Plans', module: 'children' },
  { path: ROUTES.USERS, element: <User />, title: 'Users', module: 'users' },
  { path: `${ROUTES.USERS}/view/:id`, element: <UserDetail />, title: 'View User', module: 'users' },
  { path: `${ROUTES.USERS}/edit/:id`, element: <UserDetail />, title: 'Edit User', module: 'users' },
  { path: `${ROUTES.USERS}/add`, element: <UserDetail />, title: 'Add User', module: 'users' },
  { path: ROUTES.ACTIVITY_LOGS, element: <ActivityLogsPage />, title: 'Activity Logs', module: 'activity-logs' },
  { path: ROUTES.NOTIFICATION_LOGS, element: <NotificationLogsPage />, title: 'Email Notification Logs' },
  { path: ROUTES.SETTINGS, element: <GeneralSettingsPage />, title: 'General Settings', module: 'settings' },
  { path: ROUTES.REPORTS, element: <ReportsPage />, title: 'Reports', module: 'reports' },
  { path: `${ROUTES.REPORTS}/:id`, element: <ReportDetailPage />, title: 'Report Detail', module: 'reports' },
  { path: ROUTES.ROLES, element: <RolesPage />, title: 'Roles', module: 'roles' },
  { path: ROUTES.MODULES, element: <ModulesPage />, title: 'Modules', module: 'roles' },
  { path: ROUTES.PERMISSIONS, element: <PermissionsPage />, title: 'Permissions', module: 'roles' },
  { path: `${ROUTES.ROLES}/view/:id`, element: <RoleDetail />, title: 'View Role', module: 'roles' },
  { path: `${ROUTES.ROLES}/edit/:id`, element: <RoleDetail />, title: 'Edit Role', module: 'roles' },
  { path: `${ROUTES.ROLES}/add`, element: <RoleDetail />, title: 'Add Role', module: 'roles' },
  { path: ROUTES.PROFILE, element: <MyProfile />, title: 'Profile' },
];

/**
 * Route categories for sidebar navigation
 */
export const routeCategories = {
  dashboard: {
    title: 'Dashboard',
    icon: 'HomeIcon',
    routes: [ROUTES.DASHBOARD],
  },
  vaccineManagement: {
    title: 'Vaccine Management',
    icon: 'BeakerIcon',
    routes: [
      ROUTES.VACCINES,
      ROUTES.STOCK_MANAGEMENT,
      ROUTES.VACCINATION_PLAN,
      // ROUTES.VACCINATION_RECORD,
      ROUTES.VACCINE_DISPATCH,
      ROUTES.SUPPLIER_MANAGEMENT,
    ],
  },
  locationManagement: {
    title: 'Location Management',
    icon: 'MapPinIcon',
    routes: [ROUTES.DISTRICT, ROUTES.TALUKA, ROUTES.VILLAGE, ROUTES.CENTERS],
  },
  appointments: {
    title: 'Appointments',
    icon: 'CalendarIcon',
    routes: [ROUTES.APPOINTMENTS, ROUTES.VACCINATION_RECORD],
  },
  medicalStaff: {
    title: 'Medical Staff',
    icon: 'UserGroupIcon',
    routes: [ROUTES.MEDICAL_STAFF],
  },
  patients: {
    title: 'Parent',
    icon: 'UsersIcon',
    routes: [ROUTES.PATIENTS],
  },
  users: {
    title: 'Users',
    icon: 'UsersIcon',
    routes: [ROUTES.USERS, ROUTES.ACTIVITY_LOGS],
  },
  roles: {
    title: 'Roles & Permissions',
    icon: 'ShieldCheckIcon',
    routes: [ROUTES.ROLES],
  },
};

/**
 * Legacy route redirects
 */
export const legacyRedirects = [
  { from: '/dashboard', to: FULL_PATHS.DASHBOARD },
];

/**
 * Get route by path
 */
export const getRouteByPath = (path) => {
  return [...publicRoutes, ...protectedRoutes].find(route => route.path === path);
};

/**
 * Check if route is protected
 */
export const isProtectedRoute = (path) => {
  return protectedRoutes.some(route => route.path === path || path.includes(route.path));
};

/**
 * Navigate to route helper
 * @param {string} routeKey - Key from ROUTES constant
 * @param {boolean} isProtected - Whether route needs admin prefix
 * @returns {string} Full path
 */
export const getPath = (routeKey, isProtected = true) => {
  if (isProtected && FULL_PATHS[routeKey]) {
    return FULL_PATHS[routeKey];
  }
  return ROUTES[routeKey] || routeKey;
};
